import {instance} from "../../config/axios-cnf";


export const apiGetParkingList = (data, callback, error) => {
    instance.get("/api/v1/parking/list-ticket", {params: data})
        .then(response => callback(response.data))
        .catch(err => error(err))
}
